import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import 'primeicons/primeicons.css'
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import VuePapaParse from 'vue-papa-parse'
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import Chart from 'primevue/chart';
createApp(App)
  .use(router)
  .use(store)
  .use(PrimeVue, {
    // Default theme configuration
    theme: {
        preset: Aura,
        options: {
            prefix: 'p',
            darkModeSelector: '.fake-dark-selector',            cssLayer: false
        }
    }
 })
  .use(VuePapaParse)
  .component("DataTable",DataTable)
  .component("Column",Column)
  .component("Button",Button)
  .component("Dialog",Dialog)
  .component("Dropdown", Dropdown)
  .component("Tabs",Tabs)
  .component("TabList",TabList)
  .component("Tab",Tab)
  .component("TabPanels",TabPanels)
  .component("TabPanel",TabPanel)
  .component("Chart",Chart)
  .mount("#app");
